module.exports = __webpack_public_path__ + "img/gamecult.6aaf1141.png";